export enum Movement {
  STAYED_OUT,
  ENTERED,
  STAYED_IN,
  REPARENTED,
  REORDERED,
  EXITED
}
